import React from "react";
export const Context = React.createContext(null);
const Layout = ({ children }) => <>{children}</>;
export default Layout;
